import { render, staticRenderFns } from "./TranProgramProgramModuleCreateDetail.vue?vue&type=template&id=201c93dc"
import script from "./TranProgramProgramModuleCreateDetail.vue?vue&type=script&lang=js"
export * from "./TranProgramProgramModuleCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./TranProgramProgramModuleCreateDetail.vue?vue&type=style&index=0&id=201c93dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports